import React from 'react';
import { PublicModuleStyle as S } from './PublicModule.style';
import { PublicModuleBLoC as BLoC } from './PublicModule.bloc';
import { Navigate, Route, Routes } from 'react-router';
import { PasswordChangePage } from './pages/PasswordChangePage/PasswordChangePage';
import { PasswordChangedPage } from './pages/PasswordChangedPage/PasswordChangedPage';
import { InvitationExpiredPage } from './pages/InvitationExpiredPage/InvitationExpiredPage';
import { lazyRefresh } from 'utils/lazyRefresh';

const CreateAccountPage = lazyRefresh(() => import('./pages/CreateAccountPage/CreateAccountPage'));
const PasswordResetPage = lazyRefresh(() => import('./pages/PasswordResetPage/PasswordResetPage'));
const UserInvitationPage = lazyRefresh(() => import('./pages/UserInvitationPage/UserInvitationPage'));
const LoginPage = lazyRefresh(() => import('./pages/LoginPage/LoginPage'));

const PublicModule: React.FC = () => {
  return (
    <S.Container>
      <BLoC>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/password">
            <Route path="reset" element={<PasswordResetPage />} />
            <Route path="reset/:token" element={<PasswordChangePage />} />
            <Route path="reset-finished" element={<PasswordChangedPage />} />
          </Route>
          <Route path="/invite/expired" element={<InvitationExpiredPage />} />
          <Route path="/invite" element={<UserInvitationPage />} />
          <Route path="/onboarding/*">
            <Route path="signup" element={<CreateAccountPage />} />
            <Route path="*" element={<Navigate to="signup" />} />
          </Route>
        </Routes>
      </BLoC>
    </S.Container>
  );
};

export default PublicModule;
